<script>
  export let title;
  export let folder = undefined;
</script>

<div class="content-title">
  <div class="content-title__title">{title}</div>
  {#if folder}
    <div class="content-title__folder">{folder}</div>
  {/if}
</div>

<style lang="scss">
  .content-title {
    font-size: 20px;
    line-height: 29px;
    font-weight: 600;
    color: #22252c;

    &__title {
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: 1px solid #eff1fd;
    }

    &__folder {
      margin-bottom: 16px;
      font-size: 16px;
      line-height: 23px;
      font-weight: 600;
    }
  }
</style>
